import { render, staticRenderFns } from "./AddToQuoteFooter.vue?vue&type=template&id=24da156b&scoped=true"
import script from "./AddToQuoteFooter.vue?vue&type=script&lang=ts"
export * from "./AddToQuoteFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da156b",
  null
  
)

export default component.exports